import { FC, useEffect, useState } from "react";
import { useConfirmEmailMutation } from "@entities/Shop/api/shopApiSlice";
import styles from "./styles.module.css";
import { useNavigate } from "@tanstack/react-router";

export const EmailVerificationPage: FC = () => {
  const navigate = useNavigate();
  const [confirmEmail] = useConfirmEmailMutation();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    const email = new URLSearchParams(window.location.search).get("email");

    if (!token || !email) {
      setStatus("error");
      setErrorMessage("Неверная ссылка подтверждения");
      return;
    }

    const verifyEmail = async () => {
      try {
        const response = await confirmEmail({ code: token, email }).unwrap();
        if (response.success) {
          setStatus("success");
          // Перенаправляем на главную страницу через 3 секунды
          setTimeout(() => {
            navigate({ to: "/" });
          }, 3000);
        } else {
          setStatus("error");
          setErrorMessage(response.message || "Ошибка подтверждения email");
        }
      } catch (err) {
        setStatus("error");
        setErrorMessage("Произошла ошибка при подтверждении email");
      }
    };

    verifyEmail();
  }, [confirmEmail, navigate]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {status === "loading" && (
          <>
            <h1>Подтверждение email</h1>
            <p>Пожалуйста, подождите...</p>
          </>
        )}
        {status === "success" && (
          <>
            <h1>Email подтвержден!</h1>
            <p>Вы будете перенаправлены на главную страницу...</p>
          </>
        )}
        {status === "error" && (
          <>
            <h1>Ошибка подтверждения</h1>
            <p>{errorMessage}</p>
            <button onClick={() => navigate({ to: "/" })} className={styles.button}>
              Вернуться на главную
            </button>
          </>
        )}
      </div>
    </div>
  );
}; 